"use client";

import { useTranslations } from "next-intl";
import { Alert } from "@leabankab/component-library";
import { useCurrency } from "@/hooks";

interface TopUpBannerProps {
	/** The existing Lea Bank loan the new one settles. */
	existingLoan: number;
	/** Other debt the offer requires the customer to redeem on top of it. */
	required: number;
	/** Whether the credit check supplied debts to start from. */
	hasSuggestions: boolean;
}

/** Names the part of the loan that settles the existing one, and anything else required. */
export const TopUpBanner = ({
	existingLoan,
	required,
	hasSuggestions,
}: TopUpBannerProps) => {
	const t = useTranslations("pages.RefinancePage");
	const { format } = useCurrency();

	const values = {
		existingLoan: format(existingLoan),
		amount: format(required),
	};

	return (
		<Alert severity="info" size="sm">
			{required <= 0
				? t("requiredDebts.topUp.banner", values)
				: hasSuggestions
					? t("requiredDebts.topUp.bannerWithRequiredSuggested", values)
					: t("requiredDebts.topUp.bannerWithRequired", values)}
		</Alert>
	);
};
